import React, { Component } from "react"
import { Carousel } from "react-responsive-carousel"
// import "react-responsive-carousel/lib/styles/carousel.min.css"
import "./MediaCarousel.scss"

export default class Slider extends Component {
  render() {
    const { children, ...rest } = this.props
    if ( !children || children.length === 0 ) return <div>EMPTY</div>
    return (
      <div className="Slider relative">
        <Carousel
          centerMode
          transitionTime={0}
          centerSlidePercentage={100}
          infiniteLoop={true}
          showThumbs={false}
          showArrows={true}
          showIndicators={true}
          showStatus={false}
          {...rest}
        >{children}</Carousel>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js